import { WidgetMetricKey } from "@services/math/math.service";
import { IWidget } from "../types/dashboard.types";
import { initializeCalendarData } from "src/utils/initialCalendarData";
import { create } from "zustand";
import { WIDGET_METRIC_KEYS } from "@services/math/math.const";

export interface IDashboardState {
  widgets: WidgetMetricKey[];
  availableWidgets: WidgetMetricKey[];
  modalWidgets: IWidget[];
  customSuplyWidgets: string[];
  customSalesWidgets: string[];
  setCustomSuplyWidgets: (widgets: string[]) => void;
  setCustomSalesWidgets: (widgets: string[]) => void;
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
  compareType: "raw" | "percent";
  setCompareType: (type: "raw" | "percent") => void;
  setWidgets: (widgets: WidgetMetricKey[]) => void;
  setAvailableWidgets: (availableWidgets: WidgetMetricKey[]) => void;
  setModalWidgets: (modalWidgets: IWidget[]) => void;
  setDateRange: (range: { startDate: Date; endDate: Date }) => void;
  updateWidgets: (
    widgets: WidgetMetricKey[],
    availableWidgets: WidgetMetricKey[],
  ) => void;
  reset: () => void;
}

const { today, monday } = initializeCalendarData();

export const useSuplyStore = create<IDashboardState>((set) => ({
  widgets: [],
  availableWidgets: [...WIDGET_METRIC_KEYS],
  modalWidgets: [],
  customSuplyWidgets: [
    "Transport Cost",
    "Safety Stock",
    "Shipping Costs",
    "Storage Costs",
    "Forecasting Accuracy",
    "Inventory Turnover",
    "Lost Sales",
    "Contribution Margin",
  ],

  customSalesWidgets: [
    "totalSales",
    "totalSpend",
    "contribution",
    "totalUnitsSold",
    "adRoas",
  ],

  setCustomSuplyWidgets: (widgets) => set({ customSuplyWidgets: widgets }),
  setCustomSalesWidgets: (widgets) => set({ customSalesWidgets: widgets }),
  dateRange: {
    endDate: today,
    startDate: monday,
  },
  compareType: "raw",
  setCompareType: (type: "raw" | "percent") => set({ compareType: type }),
  setWidgets: (widgets: WidgetMetricKey[]) => set({ widgets }),
  setAvailableWidgets: (availableWidgets: WidgetMetricKey[]) => {
    if (!Array.isArray(availableWidgets)) {
      return;
    }
    set({ availableWidgets });
  },
  setModalWidgets: (modalWidgets: IWidget[]) => set({ modalWidgets }),
  setDateRange: (range: { startDate: Date; endDate: Date }) =>
    set({ dateRange: range }),
  updateWidgets: (
    widgets: WidgetMetricKey[],
    availableWidgets: WidgetMetricKey[],
  ) => {
    set({ widgets, availableWidgets });
  },
  reset: () =>
    set({
      widgets: [],
      availableWidgets: [],
      modalWidgets: [],
      dateRange: { startDate: new Date(), endDate: new Date() },
      customSuplyWidgets: [],
      customSalesWidgets: [],
    }),
}));
